import React from 'react';
import loadable from 'utils/loadable';
import Spinner from 'components/Spinner/ScreenSpinner';

export default loadable(() => import('.'), {
  fallback: <Spinner />,
});
